import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  Input,
  Card,
  CardBody,
  CardTitle,
  CardSubtitle,
  Button,
  Label,
  Alert,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  UncontrolledTooltip,
} from "reactstrap";
import Switch from "react-switch";
import classnames from "classnames";
import SweetAlert from "react-bootstrap-sweetalert";
import Select from "react-select";
import Dropzone from "react-dropzone";
import { useSelector } from "react-redux";
// Redux
import { withRouter, Link } from "react-router-dom";

// Editable
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory from "react-bootstrap-table2-editor";
// availity-reactstrap-validation
import {
  AvForm,
  AvField,
  AvRadioGroup,
  AvRadio,
} from "availity-reactstrap-validation";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
//Constants
import { API_WEB_URLS } from "../../constants/constAPI";
//Store
import { compose } from "recompose";
import { container } from "../../store/Containers/cntCommon";
import {
  Fn_DisplayData,
  Fn_AddEditData,
  Fn_FillListData,
  Fn_ChangeStateValue,
} from "../../store/functions";

export const DateString = dd => {
  let d1 = dd.replace("-", "");
  let d2 = d1.replace("-", "");

  return d2;
};

const SheetPrintForCreative = props => {
  const [state, setState] = useState({
    id: 0,
    formData: {},
    activeTab: 1,
    memberid: 0,
    success_msg: false,
    JobCard_SheetSizing: [],
  });

  const formTitle = "Sheet Sizing";
  const breadCrumbTitle = "Sheet Sizing";
  const breadCrumbItem = "Print " + formTitle;

  useEffect(() => {
    const sheetSizingData = JSON.parse(
      sessionStorage.getItem("SheetSizingData")
    );
    console.log(sheetSizingData);
    if (sheetSizingData) {
      setState(prevState => ({
        ...prevState,
        JobCard_SheetSizing: sheetSizingData.JobCard_SheetSizing,
        SheetSizingData: sheetSizingData.SheetSizingData,
      }));
    }
  }, []);

  const handlePrint = () => {
    window.print();
  };

  return (
    <React.Fragment>
      <style>
        {`
          @media print {
            .no-print {
              display: none !important;
            }
            .page-content {
              margin: 0 !important;
              padding: 0 !important;
            }
            .container-fluid {
              padding: 0 !important;
              margin: 0 !important;
            }
            .card {
              border: none !important;
              box-shadow: none !important;
            }
            .card-body {
              padding: 0 !important;
            }
            .job-card {
              page-break-inside: avoid !important;
              break-inside: avoid !important;
              margin-bottom: 15px !important;
              max-width: 100% !important;
              width: 100% !important;
            }
            .row {
              margin: 0 !important;
            }
            .col {
              padding: 0 !important;
            }
          }
        `}
      </style>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <div className="no-print">
            <Breadcrumbs
              title={breadCrumbTitle}
              breadcrumbItem={breadCrumbItem}
            />

            {/* Print Button */}
            <Row className="mb-3">
              <Col>
                <Button
                  color="primary"
                  onClick={handlePrint}
                  style={{
                    float: "right",
                    marginBottom: "20px",
                  }}
                >
                  <i className="fas fa-print me-2"></i>
                  Print
                </Button>
              </Col>
            </Row>
          </div>

          <Row className="justify-content-center">
            <Col lg="10" md="12" sm="12">
              <Card>
                <CardBody>
                  <div className="page-content">
                    {/* Show VoucherDate and OrderNo once at top if same for all */}
                    {state.SheetSizingData && state.SheetSizingData.length > 0 && (() => {
                      const firstRow = state.SheetSizingData[0];
                      const isSameForAll = state.SheetSizingData.every(row => 
                        row.VoucherDate === firstRow.VoucherDate && 
                        row.OrderNo === firstRow.OrderNo
                      );
                      
                      return isSameForAll ? (
                        <div style={{ 
                          padding: "15px",
                          fontFamily: "serif",
                          maxWidth: "210mm",
                          margin: "0 auto",
                          backgroundColor: "white",
                          marginBottom: "5px",
                          fontWeight: "bold",
                          fontSize: "16px",
                          display: "flex",
                          justifyContent: "space-between"
                        }}>
                          <span>{firstRow.VoucherDate}</span>
                          <span>{firstRow.OrderNo}</span>
                        </div>
                      ) : null;
                    })()}

                    {state.SheetSizingData &&
                      state.SheetSizingData.map((row, index) => {
                        // Check if all rows have same VoucherDate and OrderNo
                        const firstRow = state.SheetSizingData[0];
                        const isSameForAll = state.SheetSizingData.every(r => 
                          r.VoucherDate === firstRow.VoucherDate && 
                          r.OrderNo === firstRow.OrderNo
                        );

                        return (
                        <div
                          key={index}
                          className="job-card"
                          style={{
                            padding: "15px",
                            fontFamily: "serif",
                            maxWidth: "210mm",
                            margin: "0 auto",
                            backgroundColor: "white",
                            marginTop: index === 0 ? "0" : "20px",
                            marginBottom: "15px",
                            border: "1px solid #ddd",
                            borderRadius: "8px",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                            pageBreakInside: "avoid",
                            breakInside: "avoid",
                          }}
                        >
                          {/* Show VoucherDate and OrderNo only if different across rows */}
                          {!isSameForAll && (
                            <div>
                              {row.VoucherDate} {row.OrderNo}
                            </div>
                          )}

                          <div
                            style={{
                              textAlign: "center",
                              fontWeight: "bold",
                              fontSize: "16px",
                              margin: "20px 0 10px 0",
                            }}
                          >
                            COD: {row.CodeNo} {"||"} ({row.Length} {row.LengthMar}){" "} {" "}<b>X</b>{" "}{" "}
                            ({row.Width} {row.WidthMar}){" "}{" "} <b>X</b>{" "}{" "}({row.Height}{" "}
                            {row.HeightMar})({row.PlyName}) {row.NoOfBox} Box{" "}
                            {row.CalculationType}{" "}
                          </div>

                          {/* Total */}

                          <div
                            style={{ textAlign: "center", fontSize: "17px" }}
                          >
                            {row.PrintDesc} {row.PrintDesc ? "||" : ""} {row.Dimensions} ( SS:{" "}
                            <span>{row.HeightX}</span> <b>X</b>{" "}
                            <span>{row.LengthX}</span> = {row.ShortQty} Sheets)
                          </div>
                        </div>
                        );
                      })}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default compose(container)(SheetPrintForCreative);
